"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDbGuideTransport1 = exports.defaultDbGuideState = void 0;
var DbBoundary_init_1 = require("@/pages/dbguide/states/DbBoundary.init");
var DbGuideLocationGroup_init_1 = require("@/pages/dbguide/states/DbGuideLocationGroup.init");
var DbGuideMenu_init_1 = require("@/pages/dbguide/states/DbGuideMenu.init");
var DbGuideState_1 = require("@/pages/dbguide/states/DbGuideState");
var defaultMapOption = {
    center: {
        lat: 22.2938141,
        lng: 114.0102928,
    },
    zoom: 15,
};
var defaultMapState = {
    id: 'm1',
    map: null,
    opts: defaultMapOption,
    objects: [],
};
var defaultDbGuidePlace1 = {
    key: 'seabeelane',
    type: DbGuideState_1.DbGuidePlaceType.DEVELOPMENT,
    center: {
        lat: 22.298883,
        lng: 114.010984,
    },
    name: 'Sea Bee Lane',
    path: [
        { lat: 22.299832, lng: 114.012337 },
        { lat: 22.299306, lng: 114.012594 },
        { lat: 22.298606, lng: 114.012905 },
        { lat: 22.297857, lng: 114.013238 },
        { lat: 22.29676, lng: 114.013715 },
        { lat: 22.295981, lng: 114.014064 },
        { lat: 22.29544, lng: 114.014316 },
        { lat: 22.295499, lng: 114.014483 },
        { lat: 22.295574, lng: 114.014676 },
        { lat: 22.295653, lng: 114.014863 },
        { lat: 22.295777, lng: 114.014965 },
        { lat: 22.295976, lng: 114.015105 },
        { lat: 22.29608, lng: 114.015169 },
        { lat: 22.296259, lng: 114.01533 },
        { lat: 22.296408, lng: 114.015437 },
        { lat: 22.296472, lng: 114.0154 },
        { lat: 22.296631, lng: 114.01525 },
        { lat: 22.296864, lng: 114.015105 },
        { lat: 22.297088, lng: 114.014981 },
        { lat: 22.297346, lng: 114.014858 },
        { lat: 22.297569, lng: 114.014772 },
        { lat: 22.297753, lng: 114.014708 },
        { lat: 22.298026, lng: 114.014649 },
        { lat: 22.298244, lng: 114.014606 },
        { lat: 22.298467, lng: 114.014525 },
        { lat: 22.298621, lng: 114.014472 },
        { lat: 22.298805, lng: 114.014397 },
        { lat: 22.299023, lng: 114.014397 },
        { lat: 22.299262, lng: 114.014456 },
        { lat: 22.29944, lng: 114.014568 },
        { lat: 22.299609, lng: 114.014686 },
        { lat: 22.299763, lng: 114.014804 },
        { lat: 22.299927, lng: 114.014906 },
        { lat: 22.300016, lng: 114.01496 },
        { lat: 22.300115, lng: 114.014976 },
        { lat: 22.30021, lng: 114.01489 },
        { lat: 22.300229, lng: 114.014799 },
        { lat: 22.300299, lng: 114.014713 },
        { lat: 22.300368, lng: 114.01466 },
        { lat: 22.300468, lng: 114.014649 },
        { lat: 22.300587, lng: 114.014617 },
        { lat: 22.300666, lng: 114.014595 },
        { lat: 22.300746, lng: 114.014515 },
        { lat: 22.300795, lng: 114.014424 },
        { lat: 22.300835, lng: 114.014338 },
        { lat: 22.300884, lng: 114.014166 },
        { lat: 22.300934, lng: 114.01401 },
        { lat: 22.300974, lng: 114.013882 },
        { lat: 22.300989, lng: 114.013748 },
        { lat: 22.300974, lng: 114.013624 },
        { lat: 22.300899, lng: 114.013533 },
        { lat: 22.30083, lng: 114.013463 },
        { lat: 22.300711, lng: 114.013399 },
        { lat: 22.300587, lng: 114.013335 },
        { lat: 22.300423, lng: 114.013259 },
        { lat: 22.300269, lng: 114.013184 },
        { lat: 22.300145, lng: 114.013034 },
        { lat: 22.300061, lng: 114.012895 },
        { lat: 22.300021, lng: 114.012718 },
        { lat: 22.299966, lng: 114.012562 },
        { lat: 22.299892, lng: 114.012439 },
        { lat: 22.299832, lng: 114.012337 },
    ],
    description: 'Beach Village was developed in 1982 and consists of low-rise buildings along Seabird, Seahorse and Seabee Lanes. The many grassy play areas and close proximity to the main beach make this village ideal for families with young children. The Plaza and the main road are a short walk away providing residents convenient access to shopping and transport.',
    photos: [
        'https://images.okay.com/DiscoveryBay/DevelopmentThumbnails/BeachVillage_1.jpg',
        'https://images.okay.com/DiscoveryBay/DevelopmentThumbnails/BeachVillage_2.jpg',
        'https://images.okay.com/DiscoveryBay/DevelopmentThumbnails/BeachVillage_3.jpg',
        'https://images.okay.com/DiscoveryBay/DevelopmentThumbnails/BeachVillage_4.jpg',
    ],
    location: DbGuideLocationGroup_init_1.defaultDbGuidLocationGroups1,
    rentLink: '#',
    saleLink: '#',
};
var defaultDbGuidePlace2 = {
    key: 'amalfi',
    type: DbGuideState_1.DbGuidePlaceType.DEVELOPMENT,
    center: {
        lat: 22.307119,
        lng: 114.012407,
    },
    name: 'Amalfi',
    path: [
        { lat: 22.3075, lng: 114.01453 },
        { lat: 22.30756, lng: 114.01469 },
        { lat: 22.30759, lng: 114.01482 },
        { lat: 22.3076, lng: 114.01497 },
        { lat: 22.30756, lng: 114.01506 },
        { lat: 22.3075, lng: 114.01515 },
        { lat: 22.30739, lng: 114.0151 },
        { lat: 22.30732, lng: 114.01502 },
        { lat: 22.30725, lng: 114.01489 },
        { lat: 22.30722, lng: 114.01476 },
        { lat: 22.30715, lng: 114.01463 },
        { lat: 22.30709, lng: 114.01455 },
        { lat: 22.307, lng: 114.01447 },
        { lat: 22.30688, lng: 114.01439 },
        { lat: 22.30687, lng: 114.01425 },
        { lat: 22.30691, lng: 114.01414 },
        { lat: 22.30701, lng: 114.01407 },
        { lat: 22.30712, lng: 114.01413 },
        { lat: 22.30734, lng: 114.0143 },
    ],
    photos: [
        'https://images.okay.com/DiscoveryBay/DevelopmentThumbnails/Amalfi_1.jpg',
        'https://images.okay.com/DiscoveryBay/DevelopmentThumbnails/Amalfi_2.jpg',
    ],
    description: 'Developed in 2011, Amalfi is made up of 3 high-rise buildings: Amalfi 1, 2 & 3. This family friendly development has a modern feel and features a large private pool serving all the units. In close proximity to the North Plaza, residents can take advantage of the sky travelator for convenient access to shopping and transport.',
    location: DbGuideLocationGroup_init_1.defaultDbGuidLocationGroups2,
    rentLink: '#',
    saleLink: '#',
};
var defaultDbGuideSchool1 = {
    key: 'discoverycollege',
    type: DbGuideState_1.DbGuidePlaceType.SCHOOL,
    center: {
        lat: 22.303933,
        lng: 114.0127094,
    },
    name: 'Discovery College',
    description: 'Discovery College is an ESF Private Independent School housed in a state of the art facility in Discovery Bay. DC offers the internationally recognised and highly regarded IB Programme - Primary Years (Years 1 to 6), Middle Years (Years 7 to 11) and Diploma (Years 12 to 13). ',
    logo: 'https://images.okay.com/DiscoveryBay/DBSchools/DiscoveryCollege_Logo.jpg',
    photos: [
        'https://images.okay.com/DiscoveryBay/DBSchools/DiscoveryCollege_1.jpg',
    ],
    contact: [
        {
            label: 'Address',
            value: '38 Siena Avenue, Discovery Bay, Hong Kong',
        },
        {
            label: 'Phone',
            value: '+85239691000',
        },
    ],
    sections: [
        {
            title: 'Teachers',
            text: 'Teacher/Student Ratio: 	1:30',
        },
        {
            title: 'Curriculum',
            text: 'International Baccalaureate - Primary Years Programme (PYP), Middle Years Programme (MYP) and Diploma Programme (DP).',
        },
    ],
};
var defaultDbGuideSchool2 = {
    key: 'dbis',
    type: DbGuideState_1.DbGuidePlaceType.SCHOOL,
    center: {
        lat: 22.3013018,
        lng: 114.0107983,
    },
    name: 'DBIS',
    description: 'Discovery Bay International School provides education for students aged 3 to 16, with Kindergarten (on a separate campus), and Primary School and Secondary School on a shared campus. This well-resourced school was established over 30 years ago and has over 950 students who represent more than 40 nationalities.',
    logo: 'https://images.okay.com/DiscoveryBay/DBSchools/DBInternationalPrimary_Logo.png',
    photos: [
        'https://images.okay.com/DiscoveryBay/DBSchools/DBInternationalPrimary_1.jpg',
    ],
    contact: [
        {
            label: 'Address',
            value: 'Discovery Bay International School, Discovery Bay, Hong Kong',
        },
        {
            label: 'Phone',
            value: '+85228977331',
        },
    ],
    sections: [
        {
            title: 'Teachers',
            text: 'Teachers: 	66<br/>Assistants: 	48<br/>Teacher/Student Ratio: 	1:14',
        },
        {
            title: 'Curriculum',
            text: "Based on the the National Curriculum of England and Wales taking into account the school's location in Hong Kong and with a strong focus on reading, writing and mathematics. The curriculum continues to evolve to reflect a balanced international approach.",
        },
    ],
};
var defaultDbGuideEmergency = {
    key: 'emergency',
    name: 'Emergency',
    center: null,
    type: DbGuideState_1.DbGuidePlaceType.EMERGENCY,
    sections: [
        {
            title: 'Emergency',
            contacts: [
                {
                    label: 'Phone',
                    value: '999',
                },
                {
                    label: 'Hours',
                    value: '24 Hours',
                },
            ],
        },
        {
            title: 'DB Fire & Ambulance',
            center: {
                lat: 22.2944019,
                lng: 114.0159832,
            },
            contacts: [
                {
                    label: 'Phone',
                    value: '+85229877507',
                },
                {
                    label: 'Hours',
                    value: '24 Hours',
                },
            ],
        },
    ],
};
var defaultDbGuideTransport1 = {
    key: 'ferry',
    name: 'Ferry Services',
    type: DbGuideState_1.DbGuidePlaceType.TRANSPORT,
    description: 'The ferry service from DB Pier is the main route for transport to and from Hong Kong island. Additional ferries operated by Kai To depart from Nim Shue Wan Pier (near the Marina Club) and connect Discovery Bay to Peng Chau Island as well as Mui Wo. ',
    app: {
        text: 'Discovery Bay Transport Ltd. has developed an app with transport schedules that you can install on your phone. Select the link below to be taken to the respective app store:',
        ios: 'https://itunes.apple.com/hk/app/db-transport-v2/id982089119?mt=8',
        android: 'https://play.google.com/store/apps/details?id=com.dbtsl.dbtransport.v2&hl=en',
    },
    photos: [
        'https://images.okay.com/DiscoveryBay/DBTransport/FerryHongKong_1.jpg',
        'https://images.okay.com/DiscoveryBay/DBTransport/FerryHongKong_3.jpg',
    ],
    routes: [
        {
            name: 'Hong Kong',
            routeName: 'DB Pier to Central (Hong Kong)',
            scheduleLink: '#',
            path: [
                [
                    {
                        lat: 22.2965813,
                        lng: 114.0178514,
                    },
                    {
                        lat: 22.2985865,
                        lng: 114.0201688,
                    },
                    {
                        lat: 22.3000953,
                        lng: 114.0222502,
                    },
                    {
                        lat: 22.3007505,
                        lng: 114.0233874,
                    },
                    {
                        lat: 22.3010681,
                        lng: 114.0242887,
                    },
                    {
                        lat: 22.3015446,
                        lng: 114.0256834,
                    },
                    {
                        lat: 22.3017431,
                        lng: 114.0270352,
                    },
                    {
                        lat: 22.3018027,
                        lng: 114.0286446,
                    },
                    {
                        lat: 22.3015644,
                        lng: 114.0300608,
                    },
                    {
                        lat: 22.3010483,
                        lng: 114.0322495,
                    },
                    {
                        lat: 22.3005122,
                        lng: 114.0340948,
                    },
                    {
                        lat: 22.3000755,
                        lng: 114.0361762,
                    },
                    {
                        lat: 22.2996784,
                        lng: 114.0389657,
                    },
                    {
                        lat: 22.2992416,
                        lng: 114.04293540000002,
                    },
                    {
                        lat: 22.2986858,
                        lng: 114.0480852,
                    },
                    {
                        lat: 22.2982093,
                        lng: 114.05495170000002,
                    },
                    {
                        lat: 22.2975938,
                        lng: 114.0608954,
                    },
                    {
                        lat: 22.2964622,
                        lng: 114.0700579,
                    },
                    {
                        lat: 22.2955291,
                        lng: 114.0770745,
                    },
                    {
                        lat: 22.2953107,
                        lng: 114.0843701,
                    },
                    {
                        lat: 22.2953107,
                        lng: 114.0862584,
                    },
                    {
                        lat: 22.294993,
                        lng: 114.0891337,
                    },
                    {
                        lat: 22.2940599,
                        lng: 114.0935969,
                    },
                    {
                        lat: 22.2926503,
                        lng: 114.098382,
                    },
                    {
                        lat: 22.2922532,
                        lng: 114.0997553,
                    },
                    {
                        lat: 22.2917966,
                        lng: 114.1035748,
                    },
                    {
                        lat: 22.2913598,
                        lng: 114.1096902,
                    },
                    {
                        lat: 22.2912804,
                        lng: 114.1114283,
                    },
                    {
                        lat: 22.2916973,
                        lng: 114.11484,
                    },
                    {
                        lat: 22.292829,
                        lng: 114.124732,
                    },
                    {
                        lat: 22.2935437,
                        lng: 114.1310406,
                    },
                    {
                        lat: 22.2942585,
                        lng: 114.1372848,
                    },
                    {
                        lat: 22.2946357,
                        lng: 114.1402459,
                    },
                    {
                        lat: 22.2947548,
                        lng: 114.1414905,
                    },
                    {
                        lat: 22.294695200000003,
                        lng: 114.145503,
                    },
                    {
                        lat: 22.294715100000005,
                        lng: 114.1484427,
                    },
                    {
                        lat: 22.294596,
                        lng: 114.150846,
                    },
                    {
                        lat: 22.2943974,
                        lng: 114.15213350000002,
                    },
                    {
                        lat: 22.294000400000005,
                        lng: 114.1535282,
                    },
                    {
                        lat: 22.2934246,
                        lng: 114.15457960000002,
                    },
                    {
                        lat: 22.2928488,
                        lng: 114.1554809,
                    },
                    {
                        lat: 22.2919951,
                        lng: 114.1566396,
                    },
                    {
                        lat: 22.2908634,
                        lng: 114.1576266,
                    },
                    {
                        lat: 22.2898906,
                        lng: 114.1580772,
                    },
                    {
                        lat: 22.2887986,
                        lng: 114.1585064,
                    },
                    {
                        lat: 22.2882427,
                        lng: 114.1585064,
                    },
                ],
            ],
        },
    ],
};
exports.defaultDbGuideTransport1 = defaultDbGuideTransport1;
var defaultDbGuideTransport2 = {
    key: 'internalbus',
    name: 'Internal Buses',
    type: DbGuideState_1.DbGuidePlaceType.TRANSPORT,
    description: 'A number of internal bus routes serve residents and visitors within Discovery Bay. The routes generally originate from the DB Pier and are timed according to the ferry schedule, servicing the different developments around DB. Bus fares are under HK$4.40 per trip, paid either using an Octopus card or cash.',
    app: {
        text: 'Discovery Bay Transport Ltd. has developed an app with transport schedules that you can install on your phone. Select the link below to be taken to the respective app store:',
        ios: 'https://itunes.apple.com/hk/app/db-transport-v2/id982089119?mt=8',
        android: 'https://play.google.com/store/apps/details?id=com.dbtsl.dbtransport.v2&hl=en',
    },
    photos: [
        'https://images.okay.com/DiscoveryBay/DBTransport/InternalBus_1.jpg',
    ],
    routes: [
        {
            name: 'No 1',
            routeName: 'DB Pier to Headland Drive',
            scheduleLink: '#',
            path: [
                [
                    {
                        lat: 22.303654,
                        lng: 114.012278,
                    },
                    {
                        lat: 22.303381,
                        lng: 114.012154,
                    },
                    {
                        lat: 22.303093,
                        lng: 114.012101,
                    },
                    {
                        lat: 22.302766,
                        lng: 114.01216,
                    },
                    {
                        lat: 22.302602,
                        lng: 114.012208,
                    },
                    {
                        lat: 22.302344,
                        lng: 114.012342,
                    },
                    {
                        lat: 22.302478,
                        lng: 114.012728,
                    },
                    {
                        lat: 22.302522,
                        lng: 114.012954,
                    },
                    {
                        lat: 22.302448,
                        lng: 114.013152,
                    },
                    {
                        lat: 22.302309,
                        lng: 114.013318,
                    },
                    {
                        lat: 22.302081000000005,
                        lng: 114.013576,
                    },
                    {
                        lat: 22.301877,
                        lng: 114.014021,
                    },
                    {
                        lat: 22.301793,
                        lng: 114.014359,
                    },
                    {
                        lat: 22.301778,
                        lng: 114.01481,
                    },
                    {
                        lat: 22.301862,
                        lng: 114.015239,
                    },
                    {
                        lat: 22.301892,
                        lng: 114.015657,
                    },
                    {
                        lat: 22.301828,
                        lng: 114.016113,
                    },
                    {
                        lat: 22.301763,
                        lng: 114.016575,
                    },
                    {
                        lat: 22.301723,
                        lng: 114.016746,
                    },
                    {
                        lat: 22.301694,
                        lng: 114.017122,
                    },
                    {
                        lat: 22.301738,
                        lng: 114.017159,
                    },
                    {
                        lat: 22.302011,
                        lng: 114.017165,
                    },
                    {
                        lat: 22.301976,
                        lng: 114.016945,
                    },
                    {
                        lat: 22.301917,
                        lng: 114.016757,
                    },
                    {
                        lat: 22.301763,
                        lng: 114.016569,
                    },
                ],
            ],
        },
    ],
};
var defaultDbGuideSport1 = {
    key: 'lantauboatclub',
    name: 'Lantau Boat Club',
    type: DbGuideState_1.DbGuidePlaceType.SPORT,
    center: {
        lat: 22.2993749,
        lng: 114.0120968,
    },
    logo: 'https://images.okay.com/DiscoveryBay/SportsRecreations/Lantau_Logo.png',
    description: 'The Lantau Boat Club caters to watersports enthusiasts specifically interested in sailing, paddling and rowing. The club is located on the main Discovery Bay Beach and is easily recognised by the saling catamarans parked in front and is regarded as one of the leading catamaran clubs in South East Asia. In addition to sailing, there is an active paddling community (Outrigger & Dragon Boat) as well as rowing.',
    photos: [
        'https://images.okay.com/DiscoveryBay/SportsRecreations/Lantau_3.jpg',
    ],
    contact: [
        {
            label: 'Phone',
            value: '+85297473860',
        },
        {
            label: 'Email',
            value: 'admin@lantauboatclub.com',
        },
    ],
};
var defaultDbGuideUseful1 = {
    key: 'usefullink',
    name: 'Useful Link',
    type: DbGuideState_1.DbGuidePlaceType.USEFUL_LINK,
    sections: [
        {
            title: 'AroundDB',
            description: 'Online and print magazine for the Discovery Bay community that shares news, events, tips as well as listings of services offered to residents and visitors to Discovery Bay',
            contacts: [
                {
                    label: 'Website',
                    value: 'http://www.arounddb.com/',
                },
            ],
        },
    ],
};
var defaultDbGuideBusiness1 = {
    key: 'banking',
    name: 'Banking',
    type: DbGuideState_1.DbGuidePlaceType.BUSINESS_DIRECTORY,
    sections: [
        {
            title: 'HSBC - Hong Kong & Shanghai Banking Corporation',
            contacts: [
                {
                    label: 'Website',
                    value: 'http://www.hsbc.com.hk',
                },
                {
                    label: 'Phone',
                    value: '+85222333000',
                },
            ],
        },
    ],
};
var defaultDbGuidePlaces = [
    defaultDbGuidePlace1,
    defaultDbGuidePlace2,
    defaultDbGuideSchool1,
    defaultDbGuideSchool2,
    defaultDbGuideEmergency,
    defaultDbGuideTransport1,
    defaultDbGuideTransport2,
    defaultDbGuideSport1,
    defaultDbGuideUseful1,
    defaultDbGuideBusiness1,
];
exports.defaultDbGuideState = {
    showWelcome: true,
    hidePanel: false,
    accordianActive: true,
    accordianHidden: false,
    detailActive: false,
    detailHidden: false,
    mapState: defaultMapState,
    menu: DbGuideMenu_init_1.defaultDbGuideMenu,
    places: defaultDbGuidePlaces,
    dbBoundaryDefinition: DbBoundary_init_1.defaultBoundary,
    stylesDefinitions: DbBoundary_init_1.defaultStyleDefinition,
    currentPlace: null,
};
